'use client'

import dynamic from "next/dynamic"
import { Fragment } from "react"
import { useOptimistic } from 'next-sanity/hooks'
import { createDataAttribute } from "next-sanity"

const StatementText = dynamic(() => import('@/components/StatementText'))
const HeadingText = dynamic(() => import('@/components/HeadingText'))
const TextBlock = dynamic(() => import('@/components/TextBlock'))
const ImageBlock = dynamic(() => import('@/components/ImageBlock'))
const VideoBlock = dynamic(() => import('@/components/VideoBlock'))
const AccordionBlock = dynamic(() => import('@/components/AccordionBlock'))
const ProcessRows = dynamic(() => import('@/components/ProcessRows'))
const ProcessGrid = dynamic(() => import('@/components/ProcessGrid'))
const ClientListMarquee = dynamic(() => import('@/components/ClientListMarquee'))
const ClientListColumns = dynamic(() => import('@/components/ClientListColumns'))
const ClientListLogos = dynamic(() => import('@/components/ClientListLogos'))
const ArticlesFeed = dynamic(() => import('@/components/ArticlesFeed'))
const PagesFeed = dynamic(() => import('@/components/PagesFeed'))
const PagesBoxes = dynamic(() => import('@/components/PagesBoxes'))
const ProjectsGrid = dynamic(() => import('@/components/ProjectsGrid'))
const AwardsList = dynamic(() => import('@/components/AwardsList'))

interface ContentBlocksProps {
	contentBlocks: any[]
	documentId: string
}

export default function ContentBlocks({contentBlocks, documentId}:ContentBlocksProps) {
	const blocks = useOptimistic(contentBlocks, (state: any, action: any) => {
		if (action.id === documentId) {
			return action?.document?.contentBlocks?.map(
				(block: any) => state?.find((s: any) => s._key === block?._key) || block
			)
		}
		return state
	})
	return (
		<div
			data-sanity={createDataAttribute({
				id: documentId,
				type: 'project',
				path: "contentBlocks",
			}).toString()}>
			{blocks?.map((block, index) => (
				<Fragment key={`item-${block?._key}-${index}`}>

					{block?._type === 'textBlock' && <TextBlock {...block} index={index} documentId={documentId} />}

					{block?._type === 'statementText' && <StatementText {...block} index={index} documentId={documentId} />}

					{block?._type === 'headingText' && <HeadingText {...block} index={index} documentId={documentId} />}

					{block?._type === 'imageBlock' && <ImageBlock {...block} index={index} documentId={documentId} />}

					{block?._type === 'video' && <VideoBlock {...block} index={index} documentId={documentId} />}

					{block?._type === 'accordionBlock' && <AccordionBlock {...block} index={index} documentId={documentId} />}

					{block?._type === 'processRows' && <ProcessRows {...block} index={index} documentId={documentId} />}

					{block?._type === 'processGrid' && <ProcessGrid {...block} index={index} documentId={documentId} />}

					{block?._type === 'clientListMarquee' && <ClientListMarquee {...block} index={index} documentId={documentId} />}

					{block?._type === 'clientListColumns' && <ClientListColumns {...block} index={index} documentId={documentId} />}

					{block?._type === 'clientListLogos' && <ClientListLogos {...block} index={index} documentId={documentId} />}

					{block?._type === 'articlesFeed' && <ArticlesFeed {...block} index={index} documentId={documentId} />}

					{block?._type === 'pagesFeed' && <PagesFeed {...block} index={index} documentId={documentId} />}

					{block?._type === 'pagesBoxes' && <PagesBoxes {...block} index={index} documentId={documentId} />}

					{block?._type === 'projectsGrid' && <ProjectsGrid {...block} index={index} documentId={documentId} />}

					{block?._type === 'awardsList' && <AwardsList {...block} index={index} documentId={documentId} />}

				</Fragment>
			))}
		</div>
	)
}